import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiFetch } from "../../helpers/api";
import "./Prices.css";

const defaultPrices = {
  groupTwoPerWeek: 275,
  groupOnePerWeek: 200,
  discountTwoPerWeek: 250,
  discountOnePerWeek: 190,
  membershipThreeMonthsDiscount: 5,
  membershipSixMonthsDiscount: 7.5,
  membershipTwelveMonthsDiscount: 10,
  privateClass: 200,
  gym: 150,
  holidayNonTraining: 50,
  holidayTraining: 250,
};

const Prices = () => {
  const { t } = useTranslation();
  const [prices, setPrices] = useState(defaultPrices);

  useEffect(() => {
    apiFetch("/api/prices")
      .then((data) => setPrices({ ...defaultPrices, ...data }))
      .catch((err) => console.error("Failed to fetch prices:", err));
  }, []);

  return (
    <section className="prices-section py-5">
      <div className="container">
        <h2 className="section-title mb-4">{t("prices.title")}</h2>

        <div className="prices-grid">
          {/* Group Classes Card */}
          <div className="price-card">
            <h4>{t("prices.groupClasses.title")}</h4>
            <ul>
              <li>
                <strong>{prices.groupTwoPerWeek} zł/{t("prices.month")}</strong> – {t("prices.groupClasses.twoPerWeek")}
              </li>
              <li>
                <strong>{prices.groupOnePerWeek} zł/{t("prices.month")}</strong> – {t("prices.groupClasses.onePerWeek")}
              </li>
            </ul>

            <h4>{t("prices.discounts.title")}</h4>
            <ul>
              <li>
                <strong>{prices.discountTwoPerWeek} zł/{t("prices.month")}</strong> – {t("prices.discounts.secondChildTwo")}
              </li>
              <li>
                <strong>{prices.discountOnePerWeek} zł/{t("prices.month")}</strong> – {t("prices.discounts.secondChildOne")}
              </li>
            </ul>
            <p className="note">{t("prices.discounts.note")}</p>
          </div>

          {/* Other Cards */}
          <div className="price-card">
            <h4>{t("prices.membership.title")}</h4>
            <ul>
              <li>{t("prices.membership.threeMonths", { discount: prices.membershipThreeMonthsDiscount })}</li>
              <li>{t("prices.membership.sixMonths", { discount: prices.membershipSixMonthsDiscount })}</li>
              <li>{t("prices.membership.twelveMonths", { discount: prices.membershipTwelveMonthsDiscount })}</li>
            </ul>
            <p className="note">{t("prices.membership.note")}</p>

            <h4>{t("prices.privateClasses.title")}</h4>
            <ul>
              <li>{t("prices.privateClasses.price", { price: prices.privateClass })}</li>
            </ul>

            <h4>{t("prices.gym.title")}</h4>
            <p>
              <strong>{prices.gym} zł/{t("prices.month")}</strong> – {t("prices.gym.access")}
            </p>

            <h4>{t("prices.holidays.title")}</h4>
            <ul>
              <li>
                <strong>{prices.holidayNonTraining} zł/{t("prices.month")}</strong> – {t("prices.holidays.nonTraining")}
              </li>
              <li>
                <strong>{prices.holidayTraining} zł/{t("prices.month")}</strong> – {t("prices.holidays.training")}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Prices;
